import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Divider from '@mui/material/Divider';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { Link as RouterLink } from 'react-router';
import { Wordmark } from '@/components/brand/Wordmark';
import { navItems, site } from '@/config/site';

export function Footer() {
  const year = new Date().getFullYear();

  return (
    <Box component="footer" sx={{ mt: 'auto', pt: { xs: 8, md: 12 }, pb: 5 }}>
      <Container>
        <Divider sx={{ mb: 5 }} />

        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={{ xs: 4, md: 2 }}
          justifyContent="space-between"
        >
          <Stack spacing={2} sx={{ maxWidth: 360 }}>
            <Wordmark size="1.6rem" />
            <Typography variant="h4" component="p">
              {site.tagline}.
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {site.description}
            </Typography>
          </Stack>

          <Stack direction="row" spacing={{ xs: 4, sm: 8 }}>
            <Stack spacing={1}>
              <Typography variant="overline" color="text.secondary">
                Site
              </Typography>
              {navItems.map((item) => (
                <Link
                  key={item.to}
                  component={RouterLink}
                  to={item.to}
                  color="text.primary"
                  variant="body2"
                >
                  {item.label}
                </Link>
              ))}
            </Stack>

            <Stack spacing={1}>
              <Typography variant="overline" color="text.secondary">
                Contact
              </Typography>
              <Link href={`mailto:${site.email}`} color="text.primary" variant="body2">
                {site.email}
              </Link>
            </Stack>
          </Stack>
        </Stack>

        {/*
          Privacy sits here rather than in navItems: it is a legal obligation to publish,
          not a page we are inviting anyone to read, and putting it in the header would
          give it the same weight as Work.
        */}
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          spacing={{ xs: 1, sm: 3 }}
          sx={{ mt: 6 }}
          alignItems={{ sm: 'baseline' }}
        >
          <Typography variant="body2" color="text.secondary">
            © {year} {site.legalName}. All rights reserved.
          </Typography>
          <Link component={RouterLink} to="/privacy" color="text.secondary" variant="body2">
            Privacy
          </Link>
        </Stack>
      </Container>
    </Box>
  );
}
